import { FC } from 'react';
import { m } from 'framer-motion';
import classNames from 'classnames';
import s from './AiBackdrop.module.scss';

const AiBackdrop: FC<{ className?: string }> = ({ className }) => (
  <m.img
    animate={{
      filter: ['hue-rotate(-90deg)', 'hue-rotate(0deg)'],
      opacity: [0.3, 1],
      transition: {
        duration: 4,
        repeat: Infinity,
        repeatType: 'mirror',
      },
    }}
    className={classNames(s.backdrop, className)}
    src="/images/dashboard/ai-modal-backdrop.webp"
  />
);

export default AiBackdrop;
